import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { database } from '../../Firebase';
import { ref, onValue, push, set, remove, update } from 'firebase/database';

const WardMahiti = () => {
    const navigate = useNavigate();
    const [isAddingNew, setIsAddingNew] = useState(false);
    const [editId, setEditId] = useState(null);
    const [wards, setWards] = useState([]);

    const [formData, setFormData] = useState({
        wardNo: '',
        wardName: '',
        wardEnglishName: '',
        isMidc: false,
        villageName: 'इनाम धामणी' // Default as per image
    });

    // Fetch Wards
    useEffect(() => {
        const wardsRef = ref(database, 'MasterData/Wards');
        const unsubscribe = onValue(wardsRef, (snapshot) => {
            const data = snapshot.val();
            const loadedWards = [];
            if (data) {
                for (let key in data) {
                    loadedWards.push({ id: key, ...data[key] });
                }
            }
            setWards(loadedWards);
        });
        return () => unsubscribe();
    }, []);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSave = () => {
        if (!formData.wardNo || !formData.wardName) {
            alert('कृपया वॉर्ड नंबर आणि नाव भरा');
            return;
        }

        const wardsRef = ref(database, 'MasterData/Wards');

        if (editId) {
             const wardRef = ref(database, `MasterData/Wards/${editId}`);
             update(wardRef, formData);
             setEditId(null);
        } else {
             const newWardRef = push(wardsRef);
             set(newWardRef, formData);
        }

        setIsAddingNew(false);
        resetForm();
    };

    const handleEdit = (ward) => {
        setFormData({
            wardNo: ward.wardNo,
            wardName: ward.wardName,
            wardEnglishName: ward.wardEnglishName || '',
            isMidc: ward.isMidc || false,
            villageName: ward.villageName || 'इनाम धामणी'
        });
        setEditId(ward.id);
        setIsAddingNew(true);
    };

    const handleDelete = (id) => {
        if (window.confirm('तुम्ही नक्की हे रेकॉर्ड हटवू इच्छिता?')) {
            const wardRef = ref(database, `MasterData/Wards/${id}`);
            remove(wardRef);
        }
    }

    const resetForm = () => {
        setFormData({
            wardNo: '',
            wardName: '',
            wardEnglishName: '',
            isMidc: false,
            villageName: 'इनाम धामणी'
        });
    };

    const handleCancel = () => {
        setIsAddingNew(false);
        setEditId(null);
        resetForm();
    };

    return (
        <div className="min-h-screen bg-gray-50 font-poppins">
             {/* Header */}
             <div className="bg-[#267c77] text-white p-4 flex items-center gap-4 shadow-md">
                <button onClick={() => navigate(-1)} className="hover:bg-white/20 p-2 rounded-full transition-colors">
                    <FiArrowLeft className="w-6 h-6" />
                </button>
                <h1 className="text-xl font-bold">वार्ड माहिती</h1>
            </div>

            <div className="max-w-5xl mx-auto p-4 md:p-8">
                <div className="bg-white rounded-lg shadow-lg overflow-hidden border border-[#267c77]/30">
                    
                    {/* List View Header */}
                    {!isAddingNew && (
                        <div className="bg-[#267c77] text-white p-4 flex justify-between items-center">
                            <h2 className="text-lg font-semibold">वार्ड यादी</h2>
                            <button 
                                onClick={() => { setIsAddingNew(true); resetForm(); }}
                                className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-4 py-1 rounded font-medium transition-colors"
                            >
                                नविन
                            </button>
                        </div>
                    )}

                    {/* Form View Header */}
                    {isAddingNew && (
                         <div className="bg-[#267c77] text-white p-4">
                            <h2 className="text-lg font-semibold">नविन वार्ड</h2>
                        </div>
                    )}

                    <div className="p-6">
                        {/* Table View */}
                        {!isAddingNew && (
                            <div className="overflow-x-auto">
                                <table className="w-full text-left border-collapse border border-gray-300">
                                    <thead className="bg-[#267c77] text-white">
                                        <tr>
                                            <th className="p-3 border border-gray-300">वार्ड क्र..</th>
                                            <th className="p-3 border border-gray-300">वार्डचे नाव</th>
                                            <th className="p-3 border border-gray-300">गावचे नाव</th>
                                            <th className="p-3 border border-gray-300">एमआयडीसी आहे का?</th>
                                            <th className="p-3 border border-gray-300 text-center">पर्याय</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {wards.map((ward) => (
                                            <tr key={ward.id} className="hover:bg-gray-50">
                                                <td className="p-3 border border-gray-300">{ward.wardNo}</td>
                                                <td className="p-3 border border-gray-300">{ward.wardName}</td>
                                                <td className="p-3 border border-gray-300">{ward.villageName}</td>
                                                <td className="p-3 border border-gray-300">{ward.isMidc ? 'true' : 'false'}</td>
                                                <td className="p-3 border border-gray-300 text-center flex justify-center gap-2">
                                                    <button 
                                                        onClick={() => handleEdit(ward)}
                                                        className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-4 py-1 rounded text-sm transition-colors"
                                                    >
                                                        बदल
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                        {wards.length === 0 && (
                                            <tr>
                                                <td colSpan="5" className="p-4 text-center text-gray-500">
                                                    माहिती उपलब्ध नाही.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                {/* Global Delete Button (as per image, though visually odd to select row first, maybe delete active/selection logic? image shows just "Radha Karne" at bottom centered) 
                                    Actually the image has a red "Radha Karne" button at the bottom of list view. Usually delete requires selection. 
                                    I will add per-row delete for better UX, or just keep it simple. 
                                    The image shows "Radha Karne" at the bottom of the table. It might be to cancel the view? 
                                    Wait, the first image shows "Radha Karne" centered below the table. 
                                    I will add it as a "Cancel/Back" button or similar behavior.
                                */}
                                <div className="flex justify-center mt-4">
                                     <button 
                                        onClick={() => navigate(-1)} // Or clear selection
                                        className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded font-medium transition-colors"
                                    >
                                        रद्द करणे
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Form View */}
                        {isAddingNew && (
                            <div className="space-y-4 animate-fade-in-down">
                                {/* Ward No */}
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                    <label className="text-gray-700 font-medium md:text-right">वार्ड क्र..</label>
                                    <input 
                                        type="text" 
                                        name="wardNo"
                                        value={formData.wardNo}
                                        onChange={handleInputChange}
                                        placeholder="वार्ड नं. भरा."
                                        className="md:col-span-3 border border-gray-300 bg-gray-100 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                                    />
                                </div>

                                {/* Ward Name */}
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                    <label className="text-gray-700 font-medium md:text-right">वार्डचे नाव</label>
                                    <input 
                                        type="text" 
                                        name="wardName"
                                        value={formData.wardName}
                                        onChange={handleInputChange}
                                        placeholder="वार्डचे नाव भरा."
                                        className="md:col-span-3 border border-gray-300 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                                    />
                                </div>

                                {/* English Name */}
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                    <label className="text-gray-700 font-medium md:text-right">वार्डचे इंग्रजी नाव</label>
                                    <input 
                                        type="text" 
                                        name="wardEnglishName"
                                        value={formData.wardEnglishName}
                                        onChange={handleInputChange}
                                        placeholder="वार्डचे इंग्रजी नाव भरा."
                                        className="md:col-span-3 border border-gray-300 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                                    />
                                </div>

                                {/* MIDC Checkbox */}
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                    <label className="text-gray-700 font-medium md:text-right">एमआयडीसी आहे का?</label>
                                    <div className="md:col-span-3">
                                        <input 
                                            type="checkbox" 
                                            name="isMidc"
                                            checked={formData.isMidc}
                                            onChange={handleInputChange}
                                            className="w-5 h-5 text-[#267c77] rounded focus:ring-[#267c77]"
                                        />
                                    </div>
                                </div>

                                {/* Village Name */}
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                                    <label className="text-gray-700 font-medium md:text-right">गावाचे नाव</label>
                                    <div className="md:col-span-3">
                                        <select 
                                            name="villageName"
                                            value={formData.villageName}
                                            onChange={handleInputChange}
                                            className="border border-gray-300 rounded px-3 py-2 w-full focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                                        >
                                            <option value="इनाम धामणी">इनाम धामणी</option>
                                            {/* Add more options if needed */}
                                        </select>
                                    </div>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex justify-center gap-4 pt-6 bg-[#267c77] -mx-6 -mb-6 p-4 mt-6">
                                     <button 
                                        onClick={handleSave}
                                        className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-6 py-2 rounded font-medium transition-colors"
                                    >
                                        साठविणे
                                    </button>
                                     <button 
                                        onClick={handleCancel}
                                        className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded font-medium transition-colors"
                                    >
                                        रद्द करणे
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WardMahiti;
